module.exports = __webpack_public_path__ + "static/media/slide-1-4.e75ba6c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/imageSlider/slide-1-4.png
// module id = 1415
// module chunks = 0